import React from "react";
import styled from "styled-components";
import Tippy from "@tippyjs/react";

import FilterChip from "../../../components/filter-chip/FilterChip";
import TagSelector from "../../../components/tag-selector/TagSelector";
// ポップオーバーの見た目は DropdownMenu の tippy テーマを流用する。
import "../../../components/dropdown-menu/dropdown-menu-tippy.css";
import type { WorkFilterTag } from "../../../types/profile";

interface WorkCategoryCellProps {
  /** タグマスタ（`ProfileContent.work_filter_tags`）。 */
  tags: WorkFilterTag[];
  selectedIds: string[];
  // eslint-disable-next-line no-unused-vars
  onChange: (ids: string[]) => void;
}

// チップは 1 行に収め、溢れたぶんは td 側の overflow: hidden で切る。
// 並びは u-row / u-gap4 に任せ、ここはセル固有の切り詰めだけを持つ。
const Trigger = styled.div.attrs({ className: "u-row u-gap4" })`
  min-height: 24px;
  cursor: pointer;
  overflow: hidden;
`;

// tippy の dropdown-menu テーマは白背景・角丸をまとめて持つ代わりに
// white-space: nowrap なので、チップを折り返せるようここで戻す。
const PopoverBody = styled.div`
  padding: 8px;
  max-width: 260px;
  white-space: normal;
`;

/**
 * 作品登録表の「カテゴリー」セル。
 *
 * 割当済みのフィルタータグ（`ProfileWork.filter_tag_ids`）をチップで表示し、
 * クリックで開くポップオーバー（`TagSelector`）でその場で付け外しできる。
 * タグマスタの追加・削除・並び替えは表の上の `FilterChipBar` が担うため、
 * ここでは割当のみを扱う（マスタが空のときは呼び出し側が列ごと出さない）。
 */
const WorkCategoryCell: React.FC<WorkCategoryCellProps> = ({
  tags,
  selectedIds,
  onChange,
}) => {
  // マスタの並び順で表示する（バーや公開ページと見え方を揃える）。
  const selected = tags.filter((tag) => selectedIds.includes(tag.id));

  return (
    <Tippy
      theme="dropdown-menu"
      animation="scale"
      duration={[100, 50]}
      trigger="click"
      interactive
      placement="bottom-start"
      arrow={false}
      offset={[0, 4]}
      appendTo={() => document.body}
      content={
        <PopoverBody>
          <TagSelector
            tags={tags}
            selectedIds={selectedIds}
            onChange={onChange}
          />
        </PopoverBody>
      }
    >
      <Trigger role="button" tabIndex={0} aria-label="カテゴリーを編集">
        {selected.length > 0 ? (
          selected.map((tag) => (
            <FilterChip key={tag.id} size="small" selected>
              {tag.name}
            </FilterChip>
          ))
        ) : (
          <span className="bodytext-13 u-text-light-gray">カテゴリーを選択</span>
        )}
      </Trigger>
    </Tippy>
  );
};

export default WorkCategoryCell;
